/**
 * 检测是否开启flash
 */
export default function flashChecker() {
    let hasFlash = 0;　　　　 //是否安装了flash
    let flashVersion = 0;　　 //flash版本
    if(navigator.plugins && navigator.plugins.length > 0) {
    // @ts-ignore
        let swf = navigator.plugins['Shockwave Flash'];
        if(swf) {
            hasFlash = 1;
            let words = swf.description.split(" ");
            for(let i = 0; i < words.length; ++i) {
                if(isNaN(parseInt(words[i]))) {
                    continue;
                }
                flashVersion = parseInt(words[i]);
            }
        }
    }
    return {
        f: hasFlash,
        v: flashVersion
    };
}

